import { createFileRoute } from '@tanstack/react-router'

import { PageBackButton } from '@/components/common/PageBackButton'
import { FeatureGate } from '@/components/feature-gate'
import { m } from '@/lib/paraglide/messages'

// Canonical example of an in-dev feature hidden behind a flag. No nav entry —
// reachable by URL only — and the content is gated by `dev-playground`. Copy
// this shape (route + FeatureGate) when starting a new in-progress feature.
export const Route = createFileRoute('/_app/_authed/_sidebar/dev-playground')({
    component: DevPlaygroundPage,
})

function DevPlaygroundPage() {
    return (
        <FeatureGate
            flag="dev-playground"
            fallback={
                <p
                    className="text-sm text-muted-foreground"
                    data-testid="dev-playground-unavailable"
                >
                    {m.dev_playground_unavailable()}
                </p>
            }
        >
            <div
                className="mx-auto max-w-2xl space-y-2 page-pad"
                data-testid="dev-playground"
            >
                <div className="flex min-w-0 items-start gap-2">
                    <PageBackButton className="-my-2 md:-my-1" />
                    <div>
                        <h1 className="text-xl font-semibold">
                            {m.dev_playground_title()}
                        </h1>
                        <p className="text-sm text-muted-foreground">
                            {m.dev_playground_description()}
                        </p>
                    </div>
                </div>
            </div>
        </FeatureGate>
    )
}
